import React from 'react';
import { BoxProps } from '@chakra-ui/react';
import JumpButton from '../../../iZUMi-UI-toolkit/src/components/Buttons/JumpButton/JumpButton';

type Props = {
    //
} & BoxProps;

const HomeJumpButton: React.FC<Props> = (props) => {
    const { ...rest } = props;

    return (
        <JumpButton
            w="30px"
            h="30px"
            target=""
            type="image"
            imageUrl={process.env.PUBLIC_URL + '/assets/sidebar/logo.svg'}
            onClick={() => {
                window.open('https://fs.bella.fi/#/flex-savings');
            }}
            {...rest}
        />
    );
};

export default HomeJumpButton;
